import { motion } from "framer-motion";

export default function Founders() {
    return (
        <section
            id="founders"
            data-testid="founders-section"
            className="relative py-28 lg:py-36 border-t border-white/5"
        >
            <div className="mx-auto max-w-3xl px-6 lg:px-10 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="text-[11px] uppercase tracking-[0.25em] font-mono text-[#10B981] font-bold">
                        Why we exist
                    </div>
                    <h2 className="mt-4 font-display text-[32px] sm:text-[40px] lg:text-[48px] font-semibold leading-[1.08] tracking-[-0.025em]">
                        Built by sales leaders,{" "}
                        <span className="text-neutral-500 italic font-light">
                            for sales leaders.
                        </span>
                    </h2>

                    <div className="relative mt-10 max-w-2xl mx-auto">
                        <svg
                            className="absolute -top-6 left-1/2 -translate-x-1/2 text-[#10B981]/25"
                            width="52"
                            height="40"
                            viewBox="0 0 52 40"
                            fill="currentColor"
                        >
                            <path d="M14 0H0v20h10c0 6-2 10-8 12v8c12-2 20-12 20-24V0zm32 0H32v20h10c0 6-2 10-8 12v8c12-2 20-12 20-24V0H46z" />
                        </svg>
                        <p className="relative pt-4 text-[18px] lg:text-[20px] leading-relaxed text-neutral-300 font-light italic">
                            "We saw our own teams losing 10 hours a week to
                            stale data — chasing names that had changed jobs
                            eighteen months ago. Dendros exists to fix the one
                            thing every CRO hates:{" "}
                            <span className="text-white not-italic font-medium">
                                a lying CRM.
                            </span>
                            "
                        </p>
                    </div>

                    <div className="mt-10 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
                        <span className="h-px w-8 bg-neutral-700" />
                        The Dendros Team
                        <span className="h-px w-8 bg-neutral-700" />
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
